import { flatten, compact } from 'lodash';
import { WithRouterProps } from 'react-router';

export function parseKeywords(
  location: WithRouterProps['location'],
  params: WithRouterProps['params'],
): string[] {
  return compact(flatten([
    location?.query?.query,
    location?.query?.make,
    params?.brand_slug,
  ]));
}
